<template>
  <TabsLayout>
    <ElTabPane name="librarymain" label="天工素材库" v-if="authMain"></ElTabPane>
    <ElTabPane name="uploadingAiAuditList" v-if="access.includes('M21218')">
      <template #label>
        <el-badge v-if="aiTagTaskCounts > 0" :value="aiTagTaskCounts" class="item"> 素材智能分析 </el-badge>
        <span v-else>素材智能分析</span>
      </template>
    </ElTabPane>
    <ElTabPane name="libraryupload" label="媒体上传任务" v-if="authUpload"></ElTabPane>
    <ElTabPane name="materialMediaRejection" label="素材拒审列表"></ElTabPane>
  </TabsLayout>
</template>
<script>
import { isArray } from '@/common/js/utils'
import TabsLayout from '@/views/report/tabs-layout.vue'
import { getAiTagTaskCounts } from '@/api/material.model'
export default {
  name: 'library',
  components: { TabsLayout },
  computed: {
    authMain() {
      return isArray(this.access) && this.access.includes('M20851')
    },
    authUpload() {
      return isArray(this.access) && this.access.includes('M20852')
    }
  },
  methods: {
    async getAiTagTaskNum() {
      if (this.$route.name === 'uploadingAiAuditList') {
        const num = await getAiTagTaskCounts()
        this.aiTagTaskCounts = num || 0
      }
    },
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      const hasAllAccess = ['M20851', 'M20852'].every((ret) => this.access.includes(ret))
      this.currentRoute = this.$route.name
      if (this.$route.name === 'library') {
        if (isArray(this.access) && hasAllAccess) {
          // 有全部Tab权限
          this.changeRouter('librarymain')
        } else {
          // 有部分Tab权限
          this.currentRoute = this.$route.name
          if (this.authMain) this.changeRouter('librarymain')
          else if (this.authUpload) this.changeRouter('libraryupload')
          else this.changeRouter('noauth')
        }
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth,
      aiTagTaskCounts: 0
    }
  },
  created() {
    this.getCurrent()

    setInterval(() => {
      this.getAiTagTaskNum()
    }, 30000)
    this.getAiTagTaskNum()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-badge__content {
  top: 8px;
  right: 2px;
}
</style>
